<div class="user-managment-filtering-options">
    <div>
        <h4>Posted Job</h4>
    </div>
    <div class="row">
        <div class="col-md-8">
            <div class="filter-by-all-option">
                <div class="form-group align-h">
                    <p class="font-size-16 filter-by-all-label">Filter By</p>
                    <div class="stretch">
                        <mat-form-field class="max-width-200">
                            <mat-select
                                placeholder
                                [(ngModel)]="selectedFilter"
                                name="filer"
                                #filter="ngModel"
                            >
                                <mat-option
                                    *ngFor="let item of filterOptionList"
                                    [value]="item"
                                >
                                    {{ item }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field
                            *ngIf="selectedFilter !== 'All'"
                            class="max-width-200 margin-left-40"
                        >
                            <mat-select
                                [placeholder]="selectedFilter"
                                [(ngModel)]="selectedSubFilter"
                                name="subfiler"
                                #filter="ngModel"
                                (selectionChange)="onChangeSubFilter($event)"
                            >
                                <mat-option
                                    *ngFor="
                    let sFilter of selectedFilter === 'Department'
                      ? departments
                      : locations
                  "
                                    [value]="sFilter"
                                >
                                    {{ sFilter }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="filter-by-name-option">
                <div class="form-group">
                    <mat-form-field>
                        <input
                            placeholder="Search by title, skill or position"
                            matInput
                            [(ngModel)]="searchText"
                            name="search"
                            #search="ngModel"
                        >
                        <mat-icon matSuffix>search</mat-icon>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
    <mat-accordion>
        <mat-expansion-panel
            *ngFor="
        let job of postedJobList
          | searchFilter: ['jobPostion', 'skills']:searchText
      "
            class="margin-bottom-20"
            (opened)="panelMap[job?.id] = true"
            (closed)="panelMap[job?.id] = false"
        >
            <mat-expansion-panel-header class="mat-expansion-panel-header--auto">
                <div class="list-item width-stretch">
                    <div class="list-item-content">
                        <div class="pipe-separated-list margin-bottom-10">
                            <h4>{{ job.jobPostion }}</h4>
                            <span>{{ job.department }}</span>
                        </div>
                        <p>{{ job.location }}</p>
                    </div>
                    <div class="list-item-action">
                        <ng-template [ngIf]="panelMap[job?.id]">
                            <button
                                mat-icon-button
                                type="button"
                                (click)="$event.stopPropagation();jobEdit(job)"
                            >
                                <img
                                    src="assets/images/Edit.png"
                                    alt="Edit"
                                >
                            </button>
                            <button
                                mat-icon-button
                                type="button"
                                (click)="$event.stopPropagation();openDialog(job)"
                            >
                                <img
                                    src="assets/images/Delete.png"
                                    alt="Delete"
                                >
                            </button>
                        </ng-template>
                        <div class="margin-right-80">
                            <!-- <mat-slide-toggle></mat-slide-toggle> -->
                            <button [disabled]="requestInProgress"
                                mat-icon-button
                                type="button"
                                *ngIf="job?.isActive === false"
                                (click)="$event.stopPropagation();onActivateJob(job)"
                            >
                                <img
                                    src="/assets/images/Inactive.png"
                                    alt="Inactive"
                                >
                            </button>
                            <button [disabled]="requestInProgress"
                                mat-icon-button
                                type="button"
                                *ngIf="job?.isActive === true"
                                (click)="$event.stopPropagation();onDeactivateJob(job)"
                            >
                                <img
                                    src="/assets/images/active.png"
                                    alt="Active"
                                >
                            </button>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel-header>
            <p [innerHTML]="job?.description"></p>
            <p>Added Skills</p>
            <h6>
                <span class="comma-separated-list">{{job?.skills}}</span>
            </h6>
        </mat-expansion-panel>
    </mat-accordion>
</div>
